document.addEventListener("DOMContentLoaded", () => {

  const lang = document.documentElement.lang.startsWith("es") ? "es" : "en";

const drawerText = {
  en: {
    title: "Battery Specifications",
    equivalent: "Equivalent Battery Codes",
    voltage: "Voltage",
    size: "Battery Size",
    chemistry: "Battery Chemistry",
    use: "Typical Use"
  },
  es: {
    title: "Especificaciones de la batería",
    equivalent: "Códigos de baterías equivalentes",
    voltage: "Voltaje",
    size: "Tamaño de la batería",
    chemistry: "Composición química",
    use: "Uso habitual"
  }
};

const t = drawerText[lang];

  const table = document.getElementById("batteryTable");

  if (!table) return;

  const rows = Array.from(table.querySelectorAll("tbody tr"));
  const search = document.getElementById("batterySearch");
  const prev = document.getElementById("prevPage");
  const next = document.getElementById("nextPage");
  const pageNumbers = document.getElementById("pageNumbers");
  const mobilePageInfo = document.querySelector(".mobile-page-info");
  const pagination = document.querySelector(".battery-pagination");
  const noResult = document.querySelector(".no-result");

  const rowsPerPage = 20;

  let currentPage = 1;
  let filteredRows = [...rows];

  function scrollToTable() {
    const target = document.querySelector(".battery-search");

    if (!target) return;

    target.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

  function renderPagination() {

    pageNumbers.innerHTML = "";

    const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

    if (totalPages <= 1) {
      pagination.style.display = "none";
    } else {
      pagination.style.display = "flex";
    }

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {

      const button = document.createElement("button");

      button.type = "button";
      button.className = "page-number";
      button.textContent = i;

      if (i === currentPage) {
        button.classList.add("active");
      }

      button.addEventListener("click", () => {
        currentPage = i;
        renderRows();
        scrollToTable();
      });

      pageNumbers.appendChild(button);

    }

    prev.disabled = currentPage === 1;
    next.disabled = currentPage === totalPages || totalPages === 0;
    mobilePageInfo.textContent = `${currentPage} / ${totalPages}`;

  }

  function renderRows() {

    rows.forEach(row => {
      row.style.display = "none";
    });

    const start = (currentPage - 1) * rowsPerPage;
    const end = start + rowsPerPage;

    filteredRows
      .slice(start, end)
      .forEach(row => {
        row.style.display = "table-row";
      });

    if (filteredRows.length === 0) {
      noResult.style.display = "block";
    } else {
      noResult.style.display = "none";
    }

    renderPagination();

  }

  search.addEventListener("input", () => {

    const keyword = search.value.trim().toLowerCase();

    filteredRows = rows.filter(row =>
      row.textContent.toLowerCase().includes(keyword)
    );

    currentPage = 1;

    renderRows();

  });

  prev.addEventListener("click", () => {

    if (currentPage === 1) return;

    currentPage--;

    renderRows();

    scrollToTable();

  });

  next.addEventListener("click", () => {

    const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

    if (currentPage >= totalPages) return;

    currentPage++;

    renderRows();

    scrollToTable();

  });

  
function initBatteryDrawer(){

    document.querySelectorAll("#batteryTable tbody tr").forEach(row=>{

        const cell=row.cells[2];

        if(!cell) return;

        const originalText = cell.textContent.trim();

let code = originalText
  .replace(/\s*\(x\d+\)/i, "")
  .replace(/\s*[×x]\d+/i, "")
  .trim();

  // Alias desteği (SR927W -> SR927SW gibi)
const batteryAlias = {
    SR927W: "SR927SW"
};

if (batteryAlias[code]) {
    code = batteryAlias[code];
}

        if (
    typeof batteryReference === "undefined" ||
    !batteryReference[code]
) return;

        if (cell.querySelector(".battery-link")) return;

cell.innerHTML = `
<span class="battery-link"
data-battery="${code}">
${originalText}
</span>`;

    });

   

    document
    .querySelector(".battery-drawer-overlay")
    .onclick=closeDrawer;

    document
    .querySelector(".battery-drawer-close")
    .onclick=closeDrawer;

}

function closeDrawer() {
    document.getElementById("batteryDrawer").classList.remove("open");
    document.getElementById("batteryDrawerContent").innerHTML = "";
}

document.addEventListener("click", function (e) {

    const link = e.target.closest(".battery-link");

    if (!link) return;

    const battery = link.dataset.battery;

    if (
        typeof batteryReference === "undefined" ||
        !batteryReference[battery]
    ) return;

    const data = batteryReference[battery];

    const lang = document.documentElement.lang.startsWith("es") ? "es" : "en";

    document.getElementById("batteryDrawerContent").innerHTML = `
     <div class="drawer-title">
    ${t.title}
</div>

<div class="drawer-code">
    ${data.battery}
</div>

        <div class="drawer-group">
            <div class="drawer-label">
                ${t.equivalent}
            </div>

            <div class="drawer-value">
                ${data.equivalents.length ? data.equivalents.join(", ") : "-"}
            </div>
        </div>

        <div class="drawer-group">
            <div class="drawer-label">
                ${t.voltage}
            </div>

            <div class="drawer-value">
                ${data.voltage}
            </div>
        </div>

        <div class="drawer-group">
            <div class="drawer-label">
                ${t.size}
            </div>

            <div class="drawer-value">
                ${data.size}
            </div>
        </div>

        <div class="drawer-group">
            <div class="drawer-label">
                ${t.chemistry}
            </div>

            <div class="drawer-value">
                ${typeof data.chemistry === "object"
                  ? data.chemistry[lang]
                  : data.chemistry}
            </div>
        </div>

        <div class="drawer-group">
            <div class="drawer-label">
                ${t.use}
            </div>

            <div class="drawer-value">
                ${typeof data.use === "object"
                  ? data.use[lang]
                  : data.use}
            </div>
        </div>
    `;

    document
        .getElementById("batteryDrawer")
        .classList.add("open");

});

document.addEventListener("keydown", function (e) {

    if (e.key === "Escape") {
        closeDrawer();
    }

});


  renderRows();
  initBatteryDrawer();

});
